import moment from 'moment'

export const TYPE_TOTAL = 'total_count'
export const TYPE_JUVENILES = 'juveniles'
export const TYPE_ADULTS = 'mobile_adult'
export const TYPE_FEMALES = 'pregnant_female'

export const LIST_VIEW_ALL_SITES = 'all'
export const LIST_VIEW_BARRIOS = 'barrios'
export const LIST_VIEW_MY_SITES = 'my'

export const FILTER_MAP_VIEW = 'filter_map_view'
export const FILTER_LIST_VIEW = 'filter_list_view'

export const getBackgroundColor = (v, type) =>
  v >= 3 && type === TYPE_FEMALES ? 'red' : 'gray'

export const VIEW_FILTER_LIST = [
  { id: LIST_VIEW_ALL_SITES, name: 'allSites' },
  { id: LIST_VIEW_BARRIOS, name: 'barrios' },
  { id: LIST_VIEW_MY_SITES, name: 'mySites' },
]

export const TYPE_FILTER_LIST = [
  { id: TYPE_FEMALES, title: 'gravidFemales' },
  { id: TYPE_ADULTS, title: 'mobileAdults' },
  { id: TYPE_JUVENILES, title: 'juvenile' },
  { id: TYPE_TOTAL, title: 'totalSeaLice' },
]

export const isTuesdayOrAfter = moment().isSameOrAfter(moment().day('Tuesday'))
export const getCurrentDate = date =>
  isTuesdayOrAfter ? moment(date) : moment(date).subtract(1, 'weeks')
